import gql from 'graphql-tag';

export const all = gql`query getCargoes($fogId: ID!) {
    cargoes(fogId: $fogId){
        id
        quantity
        perTonUsd
        value
        outturnTonnes
        customerReference
        receiver
        blDate
        blNumber
        certificateReference
        supplier
        stowage
        excessExclusion
        commodity{
            id
            name
            riskFactor
            isArchived
            commodityGroup {
                id
                name
            }
        }

        cargoPorts {
            id
            cargo {
                id
            }
            port {
                id
                name
            }
            operation
            estimatedTimeOfArrival
            isConfirmed
        }
        
        clientRate {
            id
            name
            creationDate
            client {
                id
            }
            isMarineOnly
            rate
            franchise
        }
        underwriterRate {
            id
            name
            rate
            company {
                id
                name
            }
        }
    }
}`;


export const get = gql`query getCargo($id: ID!) {
    cargo(id: $id){
        id
        quantity
        perTonUsd
        value
        outturnTonnes
        customerReference
        receiver
        blDate
        blNumber
        certificateReference
        supplier
        stowage
        excessExclusion
        commodity{
            id
            name
            riskFactor
            isArchived
            commodityGroup {
                id
                name
            }
        }

        cargoPorts {
            id
            cargo {
                id
            }
            port {
                id
                name
            }
            operation
            estimatedTimeOfArrival
            isConfirmed
        }

        clientRate {
            id
            name
            creationDate
            client {
                id
            }
            isMarineOnly
            rate
            franchise
        }
        underwriterRate {
            id
            name
            rate
            company {
                id
                name
            }
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/cargo.js